<template>
    <div class="report-dashboard">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="$route.name"></ContentHeader>
          <div class="row">
            <div class="col-sm-6"><h3>Total Nominations</h3></div>
            <!-- <div class="col-sm-6">
            <select id="totalNoms" ref="totalNoms" value="3 month ago" @change="loadTotalNomination">
              <option value="3m">Past 3 Months</option>
              <option value="6m">Past 6 Months</option>
              <option value="12m">Past 12 Months</option>
            </select>
            </div> -->
            <div class="row">
              <div class="col-sm-3 mb-2">
                  <label for="nomineeFilter">From Date:</label>
                  <input type="date" ref="totalNomsfromDate" name="totalNomsfromDate" id="totalNomsfromDate" :value="totalNomsfromDate" />
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">To Date:</label>
                <input type="date" ref="totalNomstoDate" name="totalNomstoDate" id="totalNomstoDate" :value="totalNomstoDate" />
              </div>
              <div class="col-sm-3 mb-2">
                  <label for="nomineeFilter">Business Unit:</label>
                  <select id="totalNomsBU" ref="totalNomsBU">
                    <option value="0"> --Select-- </option>
                    <option v-for="(bu, index) in filterBU" :value="bu" :key="index">
                      {{ bu }}
                    </option>
                  </select>
                  <!-- <input type="text" ref="totalNomsBU" name="totalNomsBU" id="totalNomsBU" :value="totalNomsBU" /> -->
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">Country</label>
                <select id="totalNomsCountry" ref="totalNomsCountry">
                  <option value="0"> --Select-- </option>
                  <option v-for="(country, index) in filterCountires" :value="country" :key="index">
                    {{ country }}
                  </option>
                </select>
                <input type="button" name="totalNomsSubmit" id="totalNomsSubmit" value="Search" @click="getTotalNomination" />
              </div>
            </div>
            <pie-chart :legendData="totalNomsPieLegendData" :seriesData="totalNomsPieSeriesData" height="350px"></pie-chart>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-6"><h3>Pending Nominations</h3></div>
            <!-- <div class="col-sm-6">
            <select id="pieDate" ref="pieDate" value="3 month ago" @change="loadPieChartNomination">
              <option value="3 month ago">Past 3 Months</option>
              <option value="6 month ago">Past 6 Months</option>
              <option value="12 month ago">Past 12 Months</option>
            </select>
            </div> -->
            <pie-chart :legendData="pendingNomsPieLegendData" :seriesData="pendingNomsPieSeriesData" :jsonData="pendingNomsPieData"></pie-chart>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-4"><h3>Top Nominators</h3></div>
            <!-- <div class="col-sm-4">
              <select id="barDate" ref="barDate" value="3m" @change="loadBarChartNomination">
                <option value="3m">Past 3 Months</option>
                <option value="6m">Past 6 Months</option>
                <option value="12m">Past 12 Months</option>
                <option value="All">OverAll</option>
              </select>
            </div> -->
            <div class="col-sm-4">
              <select id="barList" ref="barList" value="10" @change="getTopNominatorNomination">
                <option value="10">Top 10</option>
                <option value="20">Top 20</option>
                <option value="25">Top 25</option>
              </select>
            </div>
            <bar-chart :yAxisData="nominatoryAxisData" :xAxisData="nominatorxAxisData" :axisNames="termNames[0]" :listLimit="barListVal" :height="barListVal * 30 + 'px'" :barDate="barListDate" :authorData="nominatorAuthorData" className="nominators"></bar-chart>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-4"><h3>Top Nominees</h3></div>
            <!-- <div class="col-sm-4">
              <select id="nomineeDate" ref="nomineeDate" value="3m" @change="loadBarChartNominees">
                <option value="3m">Past 3 Months</option>
                <option value="6m">Past 6 Months</option>
                <option value="12m">Past 12 Months</option>
                <option value="All">OverAll</option>
              </select>
            </div> -->
            <div class="col-sm-4">
              <select id="nomineeList" ref="nomineeList" value="10" @change="getTopNomineesNomination">
                <option value="10">Top 10</option>
                <option value="20">Top 20</option>
                <option value="25">Top 25</option>
              </select>
            </div>
            <bar-chart :yAxisData="nomineeyAxisData" :xAxisData="nomineexAxisData" :axisNames="termNames[0]" :listLimit="nomineeListVal" :height="nomineeListVal * 30 + 'px'" :barDate="nomineeListDate" :authorData="nomineeAuthorData" className="nominees"></bar-chart>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-4"><h3>Slow Responders</h3></div>
            <!-- <div class="col-sm-4">
              <select id="responderDate" ref="responderDate" value="3m" @change="loadResponderBarChartNomination">
                <option value="3 month ago">Past 3 Months</option>
                <option value="6 month ago">Past 6 Months</option>
                <option value="12 month ago">Past 12 Months</option>
              </select>
            </div> -->
            <div class="col-sm-4">
              <select id="responderList" ref="responderList" value="10" @change="getSlowRespondersNomination">
                <option value="10">Top 10</option>
                <option value="20">Top 20</option>
                <option value="25">Top 25</option>
              </select>
            </div>
            <!-- <bar-chart :yAxisData="responderyAxisData" :xAxisData="responderxAxisData" :axisNames="termNames[0]" :listLimit="respondersListVal" className="responders"></bar-chart> -->
            <table class="table table-hover" v-if="responderTableData.length">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Days</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(email, series) in responderTableData">
                  <td>{{ email.email }}</td>
                  <td><router-link :to="{path: '/my-profile/review-nomination/' + email.id }">{{ Object.keys(email.series)[0] + ' For ' + email.series[Object.keys(email.series)[0]] + ' days' }}</router-link></td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-6"><h3>Daily / Weekly / Monthly Nominations</h3></div>
            <div class="col-sm-3">
              <select id="DWMRange" ref="DWMRange" value="3m" @change="loadDWMNominations">
                <option value="month">Monthly</option>
                <option value="week">Weekly</option>
                <option value="day">Daily</option>
              </select>
            </div>
            <div class="col-sm-3">
              <select id="DWMYear" ref="DWMYear" value="10" @change="loadDWMNominations">
                <option :value="currentYear">{{ "Year " + currentYear }}</option>
                <option :value="currentYear - 1">Year {{currentYear - 1 }}</option>
                <option :value="currentYear - 2">Year {{ currentYear - 2 }}</option>
              </select>
            </div>
            <bar-chart :yAxisData="DWMyAxisData" :xAxisData="DWMxAxisData" :axisNames="termNames[0]" :height=" (DWMyAxisData.length * 20 ) + 'px'" className="DWMNominations" :noClick=false></bar-chart>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import echarts from 'echarts'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import PreContentHeader from '@/components/PreContentHeader'
import PieChart from '@/components/PieChart'
import BarChart from '@/components/BarChart'
import $ from 'jquery'

export default {
  components: {
    PieChart,
    BarChart,
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      contentReady: false,
      filterCountires: ['South Africa', 'Tanzania', 'Kenya', 'Botswana', 'Uganda', 'Namibia', 'Ghana', 'Zambia', 'Nigeria', 'Mozambique', 'Dubai', 'Angola', 'Czech Republic'],
      filterBU: ['Dubai', 'MCG Executive', 'DMS', 'GE', 'General Management', 'MAH Corporate', 'Kenya', 'Connected Video', 'Nigeria', 'Zambia', 'Angola', 'Ghana', 'Tanzania', 'Mozambique', 'Uganda', 'Business Development', 'BTO', 'CII', 'Coporate Affairs', 'Botswana', 'Namibia', 'EBS', 'Group Finance', 'Human Resources', 'Legal (GE)', 'Regulatory', 'SA Customer ', 'Supersport', 'Technology', 'Wakanda', 'Legal', 'Strategy'],
      totalNomsCountry: '0',
      totalNomsBU: '',
      totalNomsfromDate: '',
      totalNomstoDate: '',
      contentLoadError: '',
      nominatoryAxisData: [],
      nominatorxAxisData: [],
      nomineeyAxisData: [],
      nomineexAxisData: [],
      DWMyAxisData: [],
      DWMxAxisData: [],
      nominatorAuthorData: [],
      nomineeAuthorData: [],
      responderyAxisData: [],
      responderxAxisData: [],
      responderTableData: [],
      termNames: [],
      respondersListVal: 10,
      barListVal: 10,
      barListDate: '3m',
      nomineeListVal: 10,
      nomineeListDate: '3m',
      DWMYearVal: new Date().getFullYear(),
      DWMRangeVal: 'day',
      pendingNomsPieLegendData: [],
      pendingNomsPieSeriesData: [],
      pendingNomsPieData: {},
      totalNomsPieLegendData: [],
      totalNomsPieSeriesData: [],
      totalNomsPieData: [],
      currentYear: new Date().getFullYear()
    }
  },
  created () {
    this.contentReady = true
    console.log(' changes took effect dashboard ')
  },
  mounted () {
    this.getTermNames()
    this.loadBarChartNomination()
    this.loadResponderBarChartNomination()
    this.loadPieChartNomination()
    this.loadTotalNomination()
    this.loadBarChartNominees()
    this.loadDWMNominations()
  },
  methods: {
    getTotalNomination: function(){
      let queryString = []
      if (this.$refs.totalNomsfromDate.value) {
        this.totalNomsfromDate = this.$refs.totalNomsfromDate.value
        queryString.push('fromDate=' + this.$refs.totalNomsfromDate.value)
      }
      if (this.$refs.totalNomstoDate.value) {
        this.totalNomstoDate = this.$refs.totalNomstoDate.value
        queryString.push('toDate=' + this.$refs.totalNomstoDate.value)
      }
      if (this.$refs.totalNomsCountry.value){
        this.totalNomsCountry = this.$refs.totalNomsCountry.value
        queryString.push('country=' + this.$refs.totalNomsCountry.value)
      }
      if (this.$refs.totalNomsBU.value) {
        this.totalNomsBU = this.$refs.totalNomsBU.value
        queryString.push('bu=' + this.$refs.totalNomsBU.value)
      }
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/overallfilter?' + queryString.join('&'))
        .then(response => {
          self.totalNomsPieLegendData = []
          self.totalNomsPieSeriesData = []
          self.totalNomsPieData = response.data
          $.each (self.totalNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.totalNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.totalNomsPieLegendData.push(camelCaseKey)
          })
          self.getPendingNomination()
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    getPendingNomination: function(){
      let queryString = []
      if (this.totalNomsfromDate)
        queryString.push('fromDate=' + this.totalNomsfromDate)
      if (this.totalNomstoDate)
        queryString.push('toDate=' + this.totalNomstoDate)
      if (this.totalNomsCountry)
        queryString.push('country=' + this.totalNomsCountry)
      if (this.totalNomsBU)
        queryString.push('bu=' + this.totalNomsBU)
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/pendingfilter?' + queryString.join('&'))
        .then(response => {
          self.pendingNomsPieLegendData = []
          self.pendingNomsPieSeriesData = []
          self.pendingNomsPieData = response.data
          $.each (self.pendingNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.pendingNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.pendingNomsPieLegendData.push(camelCaseKey)
          })
          self.getTopNominatorNomination()
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    getTopNominatorNomination: function(){
      let queryString = []
      if (this.totalNomsfromDate)
        queryString.push('fromDate=' + this.totalNomsfromDate)
      if (this.totalNomstoDate)
        queryString.push('toDate=' + this.totalNomstoDate)
      if (this.totalNomsCountry)
        queryString.push('country=' + this.totalNomsCountry)
      if (this.totalNomsBU)
        queryString.push('bu=' + this.totalNomsBU)
      if (this.$refs.barList.value)
        queryString.push('limit=' + this.$refs.barList.value)
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/topnominatorfilter?' + queryString.join('&'))
        .then(response => {
          this.contentReady = true
          this.nominatoryAxisData = []
          this.nominatorxAxisData = []
          this.nominatorAuthorData = []
          var data = response.data
          let xtemp = []
          let ytemp = []
          var self = this
          $.each (data, function (index, val) {
            ytemp.push( val.user_email )
            self.nominatorAuthorData[val.user_email] = val.post_author
          })
          $.each (self.termNames[0], function (i, y) {
            let d = []
            d[y] = []
            $.each (data, function (index, val) {
              d[y].push( (val.series[y]) ? val.series[y] : 0 )
            })
            if (d[y])
              xtemp.push(d[y].reverse())
          })
          this.nominatoryAxisData = ytemp.reverse()
          this.nominatorxAxisData = xtemp
          self.getTopNomineesNomination()
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    getTopNomineesNomination: function(){
      let queryString = []
      if (this.totalNomsfromDate)
        queryString.push('fromDate=' + this.totalNomsfromDate)
      if (this.totalNomstoDate)
        queryString.push('toDate=' + this.totalNomstoDate)
      if (this.totalNomsCountry)
        queryString.push('country=' + this.totalNomsCountry)
      if (this.totalNomsBU)
        queryString.push('bu=' + this.totalNomsBU)
      if (this.$refs.nomineeList.value)
        queryString.push('limit=' + this.$refs.nomineeList.value)
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/topnomineesfilter?' + queryString.join('&'))
        .then(response => {
          this.nomineeyAxisData = []
          this.nomineexAxisData = []
          this.nomineeAuthorData = []
          var data = response.data
          let xtemp = []
          let ytemp = []
          var self = this
          $.each (data, function (index, val) {
            ytemp.push( val.user_email )
            self.nomineeAuthorData[val.user_email] = val.nomineeSlug
          })
          $.each (self.termNames[0], function (i, y) {
            let d = []
            d[y] = []
            $.each (data, function (index, val) {
              d[y].push( (val.series[y]) ? val.series[y] : 0 )
            })
            if (d[y])
              xtemp.push(d[y].reverse())
          })
          this.nomineeyAxisData = ytemp.reverse()
          this.nomineexAxisData = xtemp
          self.getSlowRespondersNomination()
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    getSlowRespondersNomination: function(){
      let queryString = []
      if (this.totalNomsfromDate)
        queryString.push('fromDate=' + this.totalNomsfromDate)
      if (this.totalNomstoDate)
        queryString.push('toDate=' + this.totalNomstoDate)
      if (this.totalNomsCountry)
        queryString.push('country=' + this.totalNomsCountry)
      if (this.totalNomsBU)
        queryString.push('bu=' + this.totalNomsBU)
      if (this.$refs.responderList.value)
        queryString.push('limit=' + this.$refs.responderList.value)
      var self = this
      WordpressRestAPI.getCustomViewContent('getNomination/v1/slowrespondersfilter?' + queryString.join('&'))
        .then(response => {
          this.contentReady = true
          self.responderyAxisData = []
          self.responderxAxisData = []
          self.responderTableData = []
          let data = response.data
          $.each (data, function (key, val) {
            $.each (val, function (k, v) {
              self.responderyAxisData.push(v.email)
              self.responderxAxisData.push(v.series)
              self.responderTableData.push({'email' : v.email, 'series' : v.series, 'id' : v.post_id})
            })
          })
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadDWMNominations: function() {
      WordpressRestAPI.getCustomViewContent('getNomination/v1/dwmnominations?rangeval=' + this.$refs.DWMRange.value + '&year=' + this.$refs.DWMYear.value)
        .then(response => {
          this.DWMRangeVal = this.$refs.DWMRange.value
          this.DWMYearVal = this.$refs.DWMYear.value
          this.contentReady = true
          this.DWMyAxisData = []
          this.DWMxAxisData = []
          var data = response.data
          let xtemp = []
          let ytemp = []
          var self = this
          $.each (data, function (index, val) {
            ytemp.push(index)
          })
          $.each (self.termNames[0], function (i, y) {
            let d = []
            d[y] = []
            $.each (data, function (index, val) {
              d[y].push( (val.series[y]) ? val.series[y] : 0 )
            })
            if (d[y])
              xtemp.push(d[y].reverse())
          })
          this.DWMyAxisData = ytemp.reverse()
          this.DWMxAxisData = xtemp
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadResponderBarChartNomination: function () {
      console.log('responders')
      // this.respondersListVal = 10
      // this.responderyAxisData = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      // this.responderxAxisData = [ [30, 52, 200, 334, 390, 330, 220], [30, 52, 200, 334, 390, 330, 220], [0, 0, 0, 334, 0, 0, 0] ]
      var self = this
      // WordpressRestAPI.getCustomViewContent('getNomination/v1/slowresponders?limit=' + this.$refs.responderList.value + '&date=' + this.$refs.responderDate.value)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/slowresponders?limit=' + this.$refs.responderList.value + '&date=3m')
        .then(response => {
          self.respondersListVal = Number(this.$refs.responderList.value)
          self.contentReady = true
          self.responderyAxisData = []
          self.responderxAxisData = []
          self.responderTableData = []
          let data = response.data
          // console.log('responder Data-> ', JSON.stringify(response.data))
          $.each (data, function (key, val) {
            $.each (val, function (k, v) {
              // console.log(k, v)
              // console.log(k, v.email)
              self.responderyAxisData.push(v.email)
              self.responderxAxisData.push(v.series)
              self.responderTableData.push({'email' : v.email, 'series' : v.series, 'id' : v.post_id})
            })
            // console.log(key, val.filter( x=> x.email ))
          })
          // self.responderyAxisData.push(response.data.map( function(x) { return x.email } ))
          // self.responderxAxisData.push(response.data.map( function (x) { return x.series } ))
          console.log('responderyAxisData-> ', self.responderyAxisData)
          console.log('responderxAxisData-> ', self.responderxAxisData)        
          console.log('responderTableData-> ', self.responderTableData)
          console.log('responderTableData len-> ', self.responderTableData.length)
        })
        .catch(e => {
          console.error(e)
          self.contentReady = true
        })
    },
    getTermNames: function() {
      var self = this
      // Parent 20 is for VE Awards and its active categories include HIgh5, on the Spot and Teams
      WordpressRestAPI.getViewContent('nomination_event_category?parent=20')
        .then(function (response) {
          self.termNames.push(response.data.map(function(x){return x.name}))
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    loadTotalNomination: function() {
      var self = this
      // WordpressRestAPI.getCustomViewContent('getNomination/v1/overall?date=' + this.$refs.totalNoms.value)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/overall?date=3m')
        .then(response => {
          self.totalNomsPieLegendData = []
          self.totalNomsPieSeriesData = []
          console.log('getNS-> ', response.data)
          self.totalNomsPieData = response.data
          $.each (self.totalNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.totalNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.totalNomsPieLegendData.push(camelCaseKey)
          })
          console.log('pieSeries-> ', self.totalNomsPieSeriesData)
          console.log('pieLegend-> ', self.totalNomsPieLegendData)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadPieChartNomination: function() {
      var self = this
      // WordpressRestAPI.getCustomViewContent('getNomination/v1/pending?date=' + this.$refs.pieDate.value)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/pending?date=3m')
        .then(response => {
          self.pendingNomsPieLegendData = []
          self.pendingNomsPieSeriesData = []
          console.log('getNS-> ', response.data)
          self.pendingNomsPieData = response.data
          $.each (self.pendingNomsPieData, function (key, val) {
            let camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
            self.pendingNomsPieSeriesData.push( { value: val.length, name: camelCaseKey } )
            self.pendingNomsPieLegendData.push(camelCaseKey)
          })
          console.log('pieSeries-> ', self.pendingNomsPieSeriesData)
          console.log('pieLegend-> ', self.pendingNomsPieLegendData)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadBarChartNomination: function() {
      // WordpressRestAPI.getCustomViewContent('getNomination/v1/getTopNomination?limit=' + this.$refs.barList.value + '&date=' + this.$refs.barDate.value)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getTopNomination?limit=' + this.$refs.barList.value + '&date=3m')
        .then(response => {
          this.barListVal = Number(this.$refs.barList.value)
          // this.barListDate = this.$refs.barDate.value
          this.contentReady = true
          this.nominatoryAxisData = []
          this.nominatorxAxisData = []
          this.nominatorAuthorData = []
          var data = response.data
          let xtemp = []
          let ytemp = []
          var self = this
          $.each (data, function (index, val) {
            ytemp.push( val.user_email )
            self.nominatorAuthorData[val.user_email] = val.post_author
          })
          $.each (self.termNames[0], function (i, y) {
            let d = []
            d[y] = []
            $.each (data, function (index, val) {
              d[y].push( (val.series[y]) ? val.series[y] : 0 )
            })
            if (d[y])
              xtemp.push(d[y].reverse())
          })
          this.nominatoryAxisData = ytemp.reverse()
          this.nominatorxAxisData = xtemp
          console.log('nominatoryAxisData-> ', this.nominatoryAxisData)
          console.log('nominatorxAxisData-> ', this.nominatorxAxisData)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    },
    loadBarChartNominees: function() {
      // WordpressRestAPI.getCustomViewContent('getNomination/v1/getTopNominees?limit=' + this.$refs.nomineeList.value + '&date=' + this.$refs.nomineeDate.value)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getTopNominees?limit=' + this.$refs.nomineeList.value + '&date=3m')
        .then(response => {
          this.nomineeListVal = Number(this.$refs.nomineeList.value)
          // this.nomineeListDate = this.$refs.nomineeDate.value
          this.contentReady = true
          this.nomineeyAxisData = []
          this.nomineexAxisData = []
          this.nomineeAuthorData = []
          var data = response.data
          let xtemp = []
          let ytemp = []
          var self = this
          $.each (data, function (index, val) {
            ytemp.push( val.user_email )
            self.nomineeAuthorData[val.user_email] = val.nomineeSlug
          })
          console.log('TN ', self.termNames)
          $.each (self.termNames[0], function (i, y) {
            let d = []
            d[y] = []
            $.each (data, function (index, val) {
              d[y].push( (val.series[y]) ? val.series[y] : 0 )
            })
            if (d[y])
              xtemp.push(d[y].reverse())
          })
          this.nomineeyAxisData = ytemp.reverse()
          this.nomineexAxisData = xtemp
          console.log('nominatoryAxisData-> ', this.nomineeyAxisData)
          console.log('nominatorxAxisData-> ', this.nomineexAxisData)
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/ReportDashboard.vue